import { createReducer, on } from '@ngrx/store';
import { ProcessProgressActions } from './process-progress.actions';
import { initialProcessProgressState } from './process-progress.states';
import { DRAWINGSTATE, MAPMODE } from '../map/map-state-control';
import { MapActions } from '../map/map.actions';

export const processReducer = createReducer(
  initialProcessProgressState,

  on(ProcessProgressActions.setStep, (state, { stepCounter, processMode }) => ({
    ...state,
    stepCounter,
    processLabel: getNextProcessLabel(processMode, stepCounter),
    processMode,
  })),

  on(ProcessProgressActions.takeNextStep, (state, { processLabel, drawingState }) => {
    console.log('ProcessProgressReducer - takeNextStep to label: ', processLabel, " with state ", state);
    return ({
      ...state,
      processLabel,
      drawingState,
      stepCounter: state.stepCounter + 1,
    });
  }),

  //todo: make generic for more possible steps
  on(ProcessProgressActions.takeStepBack, (state, { processLabel }) => ({
    ...state,
    processLabel,
    drawingState: DRAWINGSTATE.UNFINISHED,
    stepCounter: state.stepCounter - 1,
  })),

  on(ProcessProgressActions.resetProcess, () => ({
    processMode: MAPMODE.DEFAULT,
    processLabel: '',
    drawingState: DRAWINGSTATE.UNFINISHED,
    stepCounter: 0,
  })),

  on(ProcessProgressActions.cancelProcess, () => ({
    processMode: MAPMODE.DEFAULT,
    processLabel: '',
    drawingState: DRAWINGSTATE.UNFINISHED,
    stepCounter: 0,
  })),

  on(MapActions.startCreateField, (state) => ({
    ...state,
    processMode: MAPMODE.FIELDCREATION,
    processLabel: 'drawing',
    stepCounter: 0,
  })),

  on(MapActions.startEditField, (state) => ({
    ...state,
    processMode: MAPMODE.FIELDEDITING,
    processLabel: 'drawing',
    stepCounter: 0,
  })),

  on(MapActions.startCreateScenario, (state) => ({
    ...state,
    processMode: MAPMODE.SCENARIOCREATION,
    processLabel: 'creating',
    stepCounter: 0,
  })),

  on(MapActions.startEditScenario, (state) => ({
    ...state,
    processMode: MAPMODE.SCENARIOCREATION,
    processLabel: 'creating',
    stepCounter: 0,
  })),


  on(MapActions.startEasyTramPlanning, (state) => ({
    ...state,
    processMode: MAPMODE.EASYTRAMPLANNING,
    processLabel: 'easyTramDeviceManager',
    stepCounter: 0,
  })),

  on(MapActions.startEditEasyTramPlan, (state) => ({
    ...state,
    processMode: MAPMODE.EASYTRAMPLANNING,
    processLabel: 'easyTramDeviceManager',
    stepCounter: 0,
  }))
);

function getNextProcessLabel(processMode: MAPMODE, nextStepCounter: number): string {
  switch (processMode) {
    case MAPMODE.EASYTRAMPLANNING:
      switch (nextStepCounter) {
        case 0:
          // Initial state
          return 'easyTramDeviceManager';
        case 1:
          // MachineSelection -> HeadlandCreation
          return 'easyTramCreateHeadland';
        case 2:
          // HeadlandCreation -> CorelandCreation
          return 'easyTramCreateCoreland';
        default:
          // Final state transition is handled in handleDrawingStateFinished
          return '';
      }
    case MAPMODE.SCENARIOCREATION:
      switch (nextStepCounter) {
        case 0:
          return 'creating';
        default:
          return '';
      }
    case MAPMODE.FIELDCREATION:
    case MAPMODE.FIELDEDITING:
      switch (nextStepCounter) {
        case 0:
          return 'drawing';
        default:
          return '';
      }
    default:
      return '';
  }
}